(function () {
    'use strict';

    function workflowDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/';

        function loadWorkflow(id) {
            return $http.get(baseUrl + id).then(function (response) {
                return response.data;
            });
        };

        function saveWorkflow(data) {
            return $http.put(baseUrl + data.Id, data).then(
                function (response) { return true; }
            );
        };

        function deleteUploadBlob(blobReference) {
            return $http.get('/Files/DeleteUploadBlob?blobReference=' + blobReference).then(
                function (response) { return response.data; });
        };


        function deleteWorkflow(id) {
            return $http.delete(baseUrl + id).then(function (response) {
                return response.data;
            });
        }

        function getEntitySearches(id) {
            return $http.get(baseUrl + id + '/entitySearches').then(function (response) {
                return response.data;
            });
        }

        function createWorkflow(data, t) {
            return $http.post(baseUrl + 'workflows/create/' + t, data).then(
                function (response) { return response.data; },
                function (response) {
                    var errorResponse = {
                        data: response.data,
                        isError: true
                   }
                    return errorResponse;
                }
            );
        }

        function createWorkflowForEntity(entityId, data, t) {
            return $http.post(baseUrl + 'workflows/create/' + t + '/entity/' + entityId.toLowerCase(),
                data).then(
                function (response) { return response.data; },
                function (response) {
                    var errorResponse = {
                        data: response.data,
                        isError: true
                   }
                   return errorResponse;
                }
            );
        }

        return {
            loadWorkflow: loadWorkflow,
            saveWorkflow: saveWorkflow,
            deleteUploadBlob: deleteUploadBlob,
            deleteWorkflow: deleteWorkflow,
            getEntitySearches: getEntitySearches,
            createWorkflow: createWorkflow,
            createWorkflowForEntity: createWorkflowForEntity
        }
    }

    workflowDataService.$inject = ['$http'];

    angular.module('ecap.common').service('workflowDataService', workflowDataService);
})();
